import { mapGetters, mapActions } from 'vuex';

import { BaTable } from '@/components/atoms/ba-table/vue/';
import BaSiteHeader from '@/components/molecules/ba-site-header/vue/ba-site-header.vue';
import BaLayout from '@/layouts/layout.vue';
import BaSection from '@/layouts/section.vue';
import { BaSpinner } from '@/components/atoms/ba-spinner/vue';

export default {
  components: {
    BaLayout,
    BaTable,
    BaSection,
    BaSiteHeader,
    BaSpinner,
  },
  data() {
    return {
      title: this.$t('authentication.loggingIn'),
    };
  },
  computed: {
    ...mapGetters({
      oidcError: 'auth/oidc/oidcError',
      isAuthenticated: 'auth/oidc/oidcIsAuthenticated',
      user: 'auth/oidc/oidcUser',
    }),
    userType() {
      if (this.user && this.user.UserType) {
        if (Array.isArray(this.user.UserType)) {
          return this.user.UserType[0].toLowerCase();
        }
        return this.user.UserType.toLowerCase();
      }
      return 'internal';
    },
  },
  async created() {
    try {
      // const defaultRoute = { name: 'default', params: { userType: this.userType, lang: 'nl' } };
      let redirectPath = '';
      if (this.$route.hash) {
        this.title = this.$t('authentication.processing');
        // console.log('Start processing OIDC callback');
        redirectPath = await this.processOidcCallback();
        if (!redirectPath || redirectPath === this.$route.path) {
          redirectPath = { name: 'default', params: { userType: this.userType, lang: 'nl' } };
        }
        // console.log('Processed OIDC callback:', redirectPath);
        this.$router.replace(redirectPath);
      } else {
        const hasAccess = await this.checkAccess({ name: 'default', params: { userType: this.userType, lang: 'nl' }, meta: {} });
        if (hasAccess) {
          // console.log('Already authenticated, redirecting to default path');
          this.title = this.$t('authentication.processing');
          this.$router.replace({ name: 'default', params: { userType: this.userType, lang: 'nl' } });
        } else {
          await this.redirectToLogin(this.$route.path);
          // If redirect hasn't happened after 3 seconds, we should check if there's a problem
          setTimeout(this.handleConfigurationError, 3000);
        }
      }
    } catch (e) {
      this.$router.replace({ name: 'authentication-error', params: { userType: this.userType, lang: 'nl' } });
    }
  },
  methods: {
    handleConfigurationError() {
      if (this.oidcError) {
        // console.log('OIDC error occurred (probably a configuration issue):', this.oidcError);
        // const message = this.$t('authentication.unknown_error');
        this.$router.replace({ name: 'authentication-error', params: { userType: this.userType, lang: 'nl' } });
      }
    },
    ...mapActions({
      checkAccess: 'auth/oidc/oidcCheckAccess',
      processOidcCallback: 'auth/oidc/oidcSignInCallback',
      redirectToLogin: 'auth/oidc/authenticateOidc',
    }),
  },
};
